export default __webpack_public_path__ + "static/media/button.708a115d.svg";